import { useState } from "react";
import { toast } from "sonner";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import HowItWorks from "@/components/sections/HowItWorks";
import Example from "@/components/sections/Example";
import Preview from "@/components/sections/Preview";
import ForWhom from "@/components/sections/ForWhom";
import Trust from "@/components/sections/Trust";
import About from "@/components/sections/About";
import Pricing from "@/components/sections/Pricing";
import Footer from "@/components/sections/Footer";
import ExampleModal from "@/components/ExampleModal";
import { createCheckout } from "@/lib/api";

export default function Landing() {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPackage, setLoadingPackage] = useState(null);

  const scrollToPricing = () => {
    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCheckout = async (packageId = "oratio_draft") => {
    setLoading(true);
    setLoadingPackage(packageId);
    try {
      const data = await createCheckout(window.location.origin, packageId);
      window.location.href = data.url;
    } catch (e) {
      console.error(e);
      toast.error("Zahlung konnte nicht gestartet werden. Bitte später erneut versuchen.");
      setLoading(false);
      setLoadingPackage(null);
    }
  };

  return (
    <div className="bg-cream min-h-screen">
      <Nav onCta={scrollToPricing} />
      <Hero onCta={scrollToPricing} onExample={() => setModalOpen(true)} />
      <HowItWorks />
      <Example onOpen={() => setModalOpen(true)} />
      <Preview onCta={scrollToPricing} />
      <ForWhom />
      <Trust />
      <About />
      <Pricing onCta={handleCheckout} loading={loading} loadingPackage={loadingPackage} />
      <Footer />
      <ExampleModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}
